import React, { useState } from "react";
import Reach from "../../components/Common/Reach/Reach";
import HomeScreen from "../HomeScreen/HomeScreen";
import "../../components/Common/scss/main.scss";
import Features from "../../components/Common/Features/Features";
import WebinarDetails from "../../components/Common/WebinarDetails/WebinarDetails";
import FeaturesList from "../../components/Common/Features/FeaturesList";
import Institutes from "../../components/Common/Institutes/Institutes";
import Footer from "../../components/Common/Footer/Footer";

export const MobileScreen = () => {
  const [showRadarScreen, setShowRadarScreen] = useState(false);

  return (
    <>
      <HomeScreen
        showRadarScreen={showRadarScreen}
        setShowRadarScreen={setShowRadarScreen}
      />
      <WebinarDetails isDesktopView={false}/>
      <Features isDesktopView={false} />
      {/* <Reach /> */}
      {/* <FeaturesList /> */}
      {/* <Institutes /> */}
      <Footer />
    </>
  );
};
